import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/zengdai/Workspace/vimwiki/Projects/Blogger/blogv3/src/components/posts-layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`A few good stuff I scavenged from Chrome wasteland.`}</p>
    <h2>{`My Chrome Plugins List`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://userstyles.org/"
        }}>{`Stylish`}</a>{`, you has to get it if you like to change e.g. Google search page, to `}<a parentName="li" {...{
          "href": "https://userstyles.org/styles/118959/darksearch-for-google"
        }}>{`dark theme`}</a>{`. It's better to use it together with `}<a parentName="li" {...{
          "href": "https://chrome.google.com/webstore/detail/material-dark/npadhaijchjemiifipabpmeebeelbmpd"
        }}>{`this`}</a>{` chrome colorscheme.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/brookhong/Surfingkeys/issues/31"
        }}>{`Surfingkey`}</a>{`, you cannot miss if you are looking for a really good vim key-binding plugin in Chrome. Check my `}<a parentName="li" {...{
          "href": "https://github.com/daizeng1984/dotfiles/blob/master/misc/surfkeys.js"
        }}>{`config`}</a>{` files if you are interested!`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/akahuku/wasavi"
        }}>{`Wasavi`}</a>{`, when surfing key plugin cannot be used for some text intput box`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://chrome.google.com/webstore/detail/emoji-cheatsheet-for-gith/nojknakoailnpbjlmfkpbbhoodlolfbh?hl=en"
        }}>{`Emoji Helper`}</a>{`, nice tool to pick your emoji and copy to clipboard`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://chrome.google.com/webstore/detail/foxclocks/obcbigljfpgappaaofailjjoabiikckk/related?hl=en"
        }}>{`FoxClocks`}</a>{`, useful if you work across timezone. Don't forget to set the status bar option to "use 'transform'" to avoid breaking website.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://chrome.google.com/webstore/detail/display-anchors/poahndpaaanbpbeafbkploiobpiiieko?hl=en"
        }}>{`Display Anchor`}</a>{`, specially handy if you want copy the "jump link" (e.g. jump to a particular answer in StackOverflow's page)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://chrome.google.com/webstore/detail/uselect-idownload/ileabdhfjmgaognikmjgmhhkjffggejc?hl=en"
        }}>{`uSelect iDownload`}</a>{`, multiple link select and download`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://chrome.google.com/webstore/detail/clear-cache/cppjkneekbjaeellbfkmgnhonkkjfpdn/related?hl=en"
        }}>{`Clear Cache`}</a>{`, Dev Tool: clear not just cache, but also others like cookies, localStorage, indexedDB etc.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://chrome.google.com/webstore/detail/jsonview/chklaanhfefbnpoihckbnefhakgolnmc/related?hl=en"
        }}>{`JSON view`}</a>{`, Dev Tool: json viewer instead of plain text.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://webmakerapp.com/"
        }}>{`Web Maker`}</a>{`, the offline Codepen for FrontEnd.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://chrome.google.com/webstore/detail/wappalyzer/gppongmhjkpfnbhagpmjfkannfbllamg?hl=en"
        }}>{`Wappalyzer`}</a>{`, Dev Tool: peek certain technologies used in current website.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://chrome.google.com/webstore/detail/tampermonkey/dhdgffkkebhmkfjojejmpbldmpobfkfo?hl=en"
        }}>{`TamperMonkey`}</a>{`, the radiated monkey living in chrome wasteland (similar species to `}<a parentName="li" {...{
          "href": "https://addons.mozilla.org/en-US/firefox/addon/greasemonkey/"
        }}>{`greasemonkey`}</a>{`), with them you could do e.g. youtube `}<a parentName="li" {...{
          "href": "https://greasyfork.org/en/scripts/20015-simple-youtube-mp3-button"
        }}>{`mp3 download button`}</a>{` and ... 🤐. `}<strong parentName="li">{`But watch out malicious scripts!`}</strong></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.amazon.com/gp/sendtokindle/chrome"
        }}>{`Send to Kindle`}</a>{`, where most TLDR goes`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://chrome.google.com/webstore/detail/google-mail-checker/mihcahmgecmbnbcchbopgniflfhgnkff?hl=en"
        }}>{`Google Mail Checker`}</a>{`, handy if you like web gmail client and have shortcut keybinding e.g. `}<kbd>{`cmd`}</kbd>{`+`}<kbd>{`G`}</kbd></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://chrome.google.com/webstore/detail/remove-youtube-recommende/hfnghnjkcpgagjbiheidccjnneoipbmb?hl=en"
        }}>{`Clean Youtube`}</a>{`, ads/recommendation free (less distraction).`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://chrome.google.com/webstore/detail/take-webpage-screenshots/mcbpblocgmgfnpjjppndjkmgjaogfceg?hl=en"
        }}>{`Screen Capture`}</a>{` for the entire webpage and export to pdf when default printer doesn't work!`}
        {
          /*- * [Restlet Client](https://chrome.google.com/webstore/detail/restlet-client-rest-api-t/aejoelaoggembcahagimdiliamlcdmfm?hl=en), 
          -*/
        }
      </li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      